import React from 'react';
import palette from '../../color-palette';

interface VeganTagProps {
  background?: string;
  tag?: string;
  className?: string;
}

const VeganTag = ({
  background = palette.background.default,
  tag = palette.secondary.main,
  className,
}: VeganTagProps) => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 14 14"
    width="20"
    height="25"
    xmlSpace="preserve"
    data-testid="vegan-tag"
    className={className}
    fill={background}
    aria-label="vegan tag"
  >
    <g>
      <path
        fill={tag}
        d="M3.88,7.88c0.05-0.21,0.09-0.41,0.13-0.62c0.11-0.53,0.24-1.05,0.34-1.58c0.17-0.85,0.32-1.61,0.48-2.46
		C4.85,3.11,4.87,2.99,4.9,2.87c0.02-0.09,0.07-0.16,0.23-0.19c0.16-0.03,1.1-0.29,1.73-0.27c0.13,0,0.17,0.06,0.22,0.15
		c0.09,0.15,0.19,0.51,0.15,0.68C7.2,3.36,7.18,3.48,7.15,3.59C6.9,4.52,6.66,5.44,6.41,6.37C6.34,6.64,6.27,6.92,6.2,7.19
		C6.09,7.58,5.98,7.97,5.82,8.35c-0.17,0.42-0.24,0.86-0.35,1.3s-0.26,1.02-0.48,1.34c-0.23,0.31-0.36,0.4-0.51,0.45
		c-0.15,0.05-0.31,0.03-0.81,0.07c-0.5,0.04-0.41-0.04-0.62-0.08c-0.22-0.04-0.37-0.49-0.52-0.78C2.4,10.37,2.27,9.88,2.15,9.35
		C2.06,8.93,1.93,8.51,1.78,8.1C1.66,7.75,1.55,7.39,1.45,7.03c-0.3-1.11-0.5-2.23-0.79-3.34C0.63,3.56,0.6,3.43,0.57,3.3
		C0.52,3.16,0.55,3.04,0.59,2.91c0.07-0.19,0.73-0.3,1.02-0.37c0.29-0.07,0.86-0.12,1-0.11c0.08,0.01,0.13,0.06,0.16,0.14
		c0.01,0.03,0.02,0.06,0.02,0.09c0.14,0.74,0.29,1.67,0.43,2.41C3.4,5.93,3.58,6.81,3.77,7.69C3.78,7.76,3.79,7.83,3.88,7.88z"
      />
      <path
        fill={tag}
        d="M13.44,9.76c-0.03,0.15-0.09,0.29-0.17,0.42c-0.21,0.34-0.5,0.61-0.84,0.82c-0.49,0.3-1.3,0.59-2.22,0.59
		c-0.65,0-0.75-0.03-1.45-0.22c-0.39-0.11-0.8-0.34-1.05-0.67c-0.16-0.22-0.34-0.43-0.49-0.65c-0.35-0.53-0.46-1.12-0.4-1.74
		C6.9,7.62,7.07,6.96,7.35,6.33c0.13-0.29,0.28-0.57,0.48-0.83c0.12-0.15,0.26-0.3,0.4-0.43C8.48,4.86,8.76,4.73,9.09,4.7
		c0.41-0.03,1.02-0.14,1.18-0.14c0.34-0.01,1.16,0.12,1.46,0.28c0.32,0.17,0.62,0.38,0.9,0.61c0.42,0.34,0.61,0.78,0.68,1.3
		c0.02,0.2,0.04,0.39,0.06,0.59c0.02,0.2-0.03,0.4-0.13,0.57c-0.09,0.16-0.2,0.31-0.31,0.45c-0.09,0.13-0.22,0.21-0.38,0.23
		c-0.34,0.06-0.69,0.11-1.03,0.17c-0.66,0.12-1.33,0.11-1.99,0.05c-0.03,0-0.06,0-0.09,0c-0.07,0-0.14,0.08-0.12,0.16
		c0.01,0.06,0.03,0.12,0.06,0.17c0.17,0.22,0.36,0.41,0.6,0.55c0.16,0.09,0.33,0.13,0.52,0.14c0.7,0.05,1.36-0.08,2-0.33
		c0.21-0.08,0.42-0.18,0.63-0.26c0.09-0.04,0.19,0,0.23,0.09C13.44,9.46,13.48,9.6,13.44,9.76z M9.34,7.51
		c0,0.01,0.01,0.02,0.04,0.08c0.53-0.05,1.04-0.11,1.55-0.16c0.1-0.01,0.17-0.09,0.15-0.19c-0.03-0.23-0.1-0.44-0.22-0.64
		c-0.07-0.11-0.17-0.18-0.3-0.18c-0.21-0.01-0.43-0.01-0.64,0.01C9.68,6.45,9.5,6.59,9.45,6.84C9.4,7.06,9.37,7.29,9.34,7.51z"
      />
    </g>
  </svg>
);

export default VeganTag;
